import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'font-awesome/css/font-awesome.min.css';

import App from './App';

const SERVICE_WORKER = '/service-worker.js?v=106'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(SERVICE_WORKER).then(
      (registration) => {
        console.log('Service Worker registered:', registration);
      },
      (err) => {
        console.error('Service Worker registration failed:', err);
      }
    );
  });
}

